import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import StatusIndicator from "../utils/StatusIndicator";

import locations_en from '../assets/js/locations_en';
import locations_pt from '../assets/js/locations_pt';
import './Location.css';

const Location = () => {
    const { lang, locationId } = useParams();
    const { i18n } = useTranslation();
    const { t } = useTranslation('location');

    const currentLang = lang || i18n.resolvedLanguage;
    const locations = currentLang === 'pt' ? locations_pt : locations_en;

    const location = locations.find(loc => loc.id === locationId);

    if (!location) {
        return <section className="container"><p>{t('location.nolocationselected')}</p></section>;
    }

    return (
        <section className="container location-page">
            <div className="row">
                <div className="col s12 m9 l10 location-details">

                    <h1 className="location-city text-primary">{location.city}</h1>
                    <h2 className="location-venue">{location.location}</h2>

                    <div className="location-image-container">
                        <img
                            src={`/assets/images/atms/${locationId}/${locationId}.jpg`}
                            alt={`${location.city} ATM`}
                            className="responsive-img location-image"
                            onError={(e) => {
                                e.target.style.display = 'none';
                            }}
                        />
                    </div>

                    <div className="location-meta">
                        <p><strong>{t('location.status')}:</strong>
                            <StatusIndicator status={location.status} />
                        </p>

                        <p><strong>{t('location.address')}:</strong></p>
                        <address>
                            {location.address.map((line, i) => (
                                <span key={i}>{line}<br /></span>
                            ))}

                        </address>

                        <a
                            href={`https://www.google.com/maps/search/?api=1&map_action=map&query=${location.pin[0]}%2C${location.pin[1]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="icon-description"
                        >
                            <i className="material-icons text-primary-light">map</i>
                            <span className='text-primary-light'>{t('location.map')}</span>
                        </a>

                        <p><strong>{t('location.hours')}:</strong></p>
                        <ul className="opening-times">
                            {location.openingTimes.map((time, i) => (
                                <li key={i}>{time}</li>
                            ))}
                        </ul>

                        <p><strong>{t('location.payment_methods')}:</strong></p>
                        <div className="payment-chips">
                            {location.payment_methods.map((m) => (
                                <span key={m} className="chip">
                                    <i className="material-icons left">
                                        {m === 'cash' ? 'attach_money' : m === 'card' ? 'credit_card' : 'payment'}
                                    </i>
                                    {t(`location.payment_labels.${m}`)}
                                </span>
                            ))}
                        </div>

                        <p className="location-description">{location.description}</p>

                        {location.infoLink && (
                            <p>
                                <a
                                    className="chip"
                                    href={location.infoLink}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <i className="material-icons left">open_in_new</i>
                                    {t('location.more_information')}
                                </a>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Location;